module.exports = __webpack_public_path__ + "img/childcount-central-monitoring.0c5761ce.svg";